/**
 * MarketplaceSwitch Component
 * Toggle between "My Network" and "Public Market" using PrimeReact SelectButton
 * Professional styling with clear visual indicators
 */

import React from 'react';
import { SelectButton } from 'primereact/selectbutton';
import { Badge } from 'primereact/badge';

const MarketplaceSwitch = ({
    value = 'public',
    onChange,
    disabled = false,
    showDescription = false,
    networkCount = null,
    publicCount = null,
    compact = false,
    fullWidth = false,
    className = ''
}) => {
    const options = [
        {
            value: 'network',
            label: compact ? 'Network' : 'My Network',
            icon: 'pi-users',
            description: 'Browse leads from agents in your organization',
            count: networkCount
        },
        {
            value: 'public',
            label: compact ? 'Public' : 'Public Market',
            icon: 'pi-globe',
            description: 'Browse leads from all verified agents on the platform',
            count: publicCount
        }
    ];

    const itemTemplate = (option) => (
        <div className="flex align-items-center gap-1" style={{ padding: compact ? '0.15rem 0.25rem' : '0.25rem 0.5rem' }}>
            <i className={`pi ${option.icon}`} style={{ fontSize: compact ? '0.65rem' : '0.8rem' }} />
            <span className="font-medium" style={{ fontSize: compact ? '0.65rem' : '0.8rem' }}>{option.label}</span>
            {option.count !== null && (
                <Badge
                    value={option.count}
                    severity={value === option.value ? 'contrast' : 'secondary'}
                    className="ml-1"
                    style={{ fontSize: '0.55rem', minWidth: '1.1rem', height: '1.1rem', lineHeight: '1.1rem' }}
                />
            )}
        </div>
    );

    const handleChange = (e) => {
        if (e.value && onChange) {
            onChange(e.value);
        }
    };

    const currentOption = options.find(o => o.value === value);

    // Inline styles for full width mode
    const fullWidthStyle = fullWidth ? {
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
    } : {};

    // Build pt props
    const ptProps = {
        button: {
            style: {
                padding: compact ? '0.3rem 0.5rem' : '0.35rem 0.65rem',
                fontSize: compact ? '0.65rem' : '0.8rem',
                ...(fullWidth ? { flex: 1, justifyContent: 'center' } : {})
            }
        }
    };

    return (
        <div className={`${fullWidth ? 'w-full' : ''} ${className}`}>
            <SelectButton
                value={value}
                onChange={handleChange}
                options={options}
                optionLabel="label"
                optionValue="value"
                itemTemplate={itemTemplate}
                disabled={disabled}
                allowEmpty={false}
                className={`marketplace-switch ${fullWidth ? 'w-full' : ''}`}
                style={fullWidthStyle}
                pt={ptProps}
            />
            {showDescription && currentOption && (
                <div className="flex align-items-center gap-2 mt-2 text-500" style={{ fontSize: '0.7rem' }}>
                    <i className={`pi ${currentOption.icon}`} style={{ fontSize: '0.65rem' }} />
                    <span>{currentOption.description}</span>
                </div>
            )}
        </div>
    );
};

export default MarketplaceSwitch;
